import { CompanyEntity } from '../common/entity';
import { ProductTransactionSpecifiers } from '../productTransaction';
import { WithCustomFields } from '../custom_field/customField';
import { applyMixins } from '../../util/mixins';
import { StockLocationRole } from '../stock_location_role_assignment/stockLocationRoleAssignment';
import { EntityAuthorization } from '../common/entityAuthorization';
import { Address } from '../common/address';
import { FlowType } from './orderFlow';

export enum OrderParentType {
  order = 'order',
  task = 'task',
}

export class Order extends CompanyEntity {
  public flowId!: string;
  public statusId!: string;
  public type!: FlowType;

  public fromStockLocationId: string | undefined;
  public toStockLocationId: string | undefined;
  public assignedTo: string[] = [];

  public products: Map<string, ProductTransactionSpecifiers> = new Map();

  public parentType?: OrderParentType;
  public parentId?: string;

  public number?: string;

  public contactId?: string = undefined;
  public address?: Address;

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, obj);
    this.customFields = WithCustomFields.toCustomFieldsMap(obj);
  }
}

export class OrderAuthorization extends EntityAuthorization<Order> {
  forCreate = () => StockLocationRole.STOCK_LOCATION_SUPERVISOR;
  forUpdate = () => StockLocationRole.STOCK_LOCATION_SUPERVISOR;
  forDelete = () => StockLocationRole.STOCK_LOCATION_SUPERVISOR;
  forGet = () => StockLocationRole.STOCK_LOCATION_VIEWER;

  forProcess = () => StockLocationRole.STOCK_LOCATION_USER;
}

export interface Order extends WithCustomFields {}
applyMixins(Order, [WithCustomFields]);
